import loadJS from 'fg-loadjs'
import SVGInject from '@iconfu/svg-inject'

const phaserURL = 'https://cdn.jsdelivr.net/npm/phaser@3.15.1/dist/phaser-arcade-physics.min.js'
const image = document.getElementsByClassName('four-o-four-image')[0]
const container = document.getElementById('four-o-four-game__container')
const gameImage = document.getElementById('four-o-four-game__image')
const start = document.getElementById('four-o-four-game__start')
const game = document.getElementById('four-o-four-game')

function loadPhaser () {
  return new Promise(
    (resolve) => {
      loadJS(phaserURL, resolve)
    }
  )
}

function loadGame () {
  return import('@carwow/dead_end')
}

function showGame () {
  image.parentElement.style.display = 'none'

  container.style.display = 'block'
  container.parentElement.style.display = 'block'

  SVGInject(gameImage.children[0], { makeIdsUnique: false })
}

function fadeInGame () {
  gameImage.children[0].classList.add('loaded')
  start.classList.add('four-o-four-game__start--fadeout')
  game.classList.add('four-o-four-game__canvas--fadein')

  setTimeout(() => { start.style.display = 'none' }, 500)
}

function startGame () {
  start.classList.add('four-o-four-game__start--nohover')
  start.removeEventListener('click', startGame)
  start.innerHTML = 'Loading'

  loadPhaser()
    .then(loadGame)
    .then(fadeInGame)
}

start.addEventListener('click', startGame)

export {
  showGame
}
